import "./Footer.css";
import Logo from "../../assets/img/logo_net_viet.png";
import Ubereats from "../../assets/img/ubereats.png";
import Tripadvisor from "../../assets/img/tripadvisor.png";

const Footer = () => {

    return (
        <footer id="footer">
            <div id="footer_content">
                <div class="footer_column"><img src={Logo} alt="Net Viet Rueil Malmaison" title="Net-viet" class="footer_logo"/></div>
                <div class="footer_column">
                    <h3>NET-VIET</h3>
                    <a href="https://goo.gl/maps/6ayY7oX2rSNvwuQE7" target="_blank" rel="noreferrer"><p>1 Rue Jacques Daguerre, 92500 Rueil Malmaison</p></a>
                    <a href="tel:0617496881"><p>06 17 49 68 81</p></a>
                    <p>© 2022 par Net Viet - DONG THUAN</p>
                </div>
                <div class="footer_column">
                    <h3>NOUS SUIVRE</h3>
                    <a href="https://www.ubereats.com/fr/store/net-viet/v4u1WjG3SuyYOS1dJVQrRg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMjIlMjBSdWUlMjBKYWNxdWVzJTIwRGFndWVycmUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKNWJaUmYyMWo1a2NSbFYtVGVNamxIR0klMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNDguODg5MzcyJTJDJTIybG9uZ2l0dWRlJTIyJTNBMi4xNzAwNiU3RA%3D%3D" rel="noreferrer" target="_blank"><img src={Ubereats} alt="Net Viet Uber Eats" title="Net Viet Uber Eats" class="social_media"/></a>
                    <a href="https://www.tripadvisor.fr/Restaurant_Review-g226861-d24019030-Reviews-Net_Viet-Rueil_Malmaison_Hauts_de_Seine_Ile_de_France.html" rel="noreferrer" target="_blank"><img src={Tripadvisor} alt="Net Viet Tripadivisor" title="Net Viet Tripadvisor" class="social_media"/></a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;